import { find, update } from './generic';
import { dciGradingFields, dciSubmissionsFields, gradingFields, gradingOrdersFields } from './metadata/grading';
import { userFields } from './metadata/users';

export function createGradingOptions(base) {
  return {
    managedFields: [
      gradingFields.CARD_NAME,
      gradingFields.CARD_NUMBER,
      gradingFields.DECLARED_VALUE,
      gradingFields.HARD_CASE,
      gradingFields.SERVICE_LEVEL,
      gradingFields.SET,
      gradingFields.SUBMISSION_NUMBER,
      gradingFields.USER_ID,
      gradingFields.USER_NAME,
      gradingFields.YEAR,
    ],
    route: `/airtable/${base}/Grading`,
  };
}

export function createGradingOrdersOptions(base) {
  return {
    managedFields: [
      gradingOrdersFields.CHECKED_IN,
      gradingOrdersFields.COMPLETED,
      gradingOrdersFields.ORDER_NUMBER,
      gradingOrdersFields.STATUS,
    ],
    route: `/airtable/${base}/Orders`,
  };
}

export function createDCIGradingOptions(base) {
  const options = createGradingOptions(base);

  return {
    ...options,
    managedFields: [
      ...options.managedFields,
      // dciGradingFields.DCI_ACTION,
      dciGradingFields.DECLARED_VALUE,
      dciGradingFields.DESTINATION,
      // dciGradingFields.SERVICE_LEVEL,
    ],
  };
}

export function createDCISubmissionsOptions(base) {
  return {
    route: `/airtable/${base}/Submissions`,
  };
}

async function fetchRecords(base, user) {
  const userID = user?.airtable?.fields[userFields.USER_ID];

  if (userID) {
    const filter = `{${gradingFields.USER_ID}} = ${userID}`;
    return find(createGradingOptions(base), filter);
  }

  return [];
}

async function fetchDCISubmissions(base, ids = []) {
  if (ids.length > 0) {
    const filter = `OR(${ids.map(id => `{${dciSubmissionsFields.SUBMISSION_NUMBER}} = ${id}`).join(', ')})`;
    return find(createDCISubmissionsOptions(base), filter);
  }

  return [];
}

async function updateDCIAction(base, records) {
  records = records.map(record => {
    return {
      id: record.id,
      fields: {
        [dciGradingFields.DCI_ACTION]: record[dciGradingFields.DCI_ACTION],
        [dciGradingFields.DECLARED_VALUE]: record[dciGradingFields.DECLARED_VALUE],
        [dciGradingFields.DESTINATION]: record[dciGradingFields.DESTINATION],
        [dciGradingFields.SERVICE_LEVEL]: record[dciGradingFields.SERVICE_LEVEL],
      },
    };
  });

  return update(createDCIGradingOptions(base), records);
}

export {
  fetchDCISubmissions,
  fetchRecords,
  updateDCIAction,
};
